/********************************************************************************
 * Copyright (c) 2020 Cedalo AG
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import DefaultShapeRenderer from './DefaultShapeRenderer';

/**
 * Class to provid a renderer for a RectangleShape. Currently this class relies
 * on the DefaultShapeRenderer.
 *
 * @class RectangleShapeRenderer
 * @extends DefaultShapeRenderer
 * @constructor
 */
class RectangleShapeRenderer extends DefaultShapeRenderer {}

export default RectangleShapeRenderer;



// WEBPACK FOOTER //
// ../jsg-ui/src/graph/view/shapes/RectangleShapeRenderer.js